/**
 * Used to sync `.batch-actions-panel` styles narrow styles and Tooltip showing
 * @type {number}
 */
const BATCH_PANEL_NARROW_MAX_WIDTH = 1390;

export {
  BATCH_PANEL_NARROW_MAX_WIDTH,
};
